@if (items) {
  <span class="{{spanClass}}" matTooltip="{{scopeString(items)}}">
    {{getFirstRecord()}}
    @if (items?.length > 1) {
      <span class="symbol">+</span>
    }
    @if (items?.length > 1) {
      <span class="symbol_box">{{items?.length - 1}}</span>
    }
  </span>
}

